import React from 'react'
import { Link } from 'react-router-dom'
import { Container, Button } from 'react-bootstrap'

const NotFoundPage = () => {
	return (
		<Container className='text-center mt-5'>
			<h1>404 - Page Not Found</h1>
			<p>The page you're looking for doesn't exist.</p>
			<Button as={Link} to='/' variant='primary'>
				Go Home
			</Button>
		</Container>
	)
}

export default NotFoundPage
